import { HTMLAttributes } from 'react';
import DOMPurify from 'dompurify';

interface IProps
  extends Omit<
    HTMLAttributes<HTMLDivElement>,
    'children' | 'dangerouslySetInnerHTML'
  > {
  html: string;
}

// HTML de fora (mensagens da Comunix): config padrão do DOMPurify, que tira script,
// on* e javascript:. Duas exceções para não mudar a tela: `target` nos links (o padrão
// o remove) e FORCE_BODY, para um <style> no início da mensagem não ser descartado.
const SANITIZE_CONFIG = { ADD_ATTR: ['target'], FORCE_BODY: true };

export const SafeHtml = ({ html, ...props }: IProps) => (
  <div
    {...props}
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(html, SANITIZE_CONFIG),
    }}
  />
);
